import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { IPTrackerSettingsConfigModel, IPTrackerSettingsModel } from '../../models/start-up-config/ip-tracker-settings-config';
import { TrackUserIpRequestModel } from '../../models/tracker/track-user-ip-request';
import { CustomizedHttpService } from '../base/customized-http.service';
import { CookieService } from '../util/cookie.service';

@Injectable({
  providedIn: 'root'
})
export class IpTrackerService {
  constructor(
    private httpService: CustomizedHttpService,
    private cookieService: CookieService,
    private _httpClient: HttpClient
  ) {}

  initIPTracker(ipTrackerSettings: IPTrackerSettingsConfigModel, sessionTrackingId: string) {
    if (!ipTrackerSettings.isEnabled) {
      return;
    }

    // Get value from cookie to check if already stored for the same session
    const isNewSession = this.CheckIfNewSession(ipTrackerSettings.settings.cookieKey);
    if (isNewSession) {
      this.getIPDetails(ipTrackerSettings.settings, sessionTrackingId);
    }

    // return this.httpService.post<any, null>("ipTracker/initIPTracker", request);
  }

  getIPDetails(trackerSettings: IPTrackerSettingsModel, sessionTrackingId: string) {
    this._httpClient
      .get(trackerSettings.getIPDetailsApiEndPoint)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response != null) {
          const details = new TrackUserIpRequestModel();
          details.ipAddress = response['query'];
          details.lattitude = response['lat'];
          details.longitude = response['lon'];
          details.zipCode = response['zip'];
          details.autonomousSystemNumber = response['as'];
          details.city = response['city'];
          details.sessionTrackingId = sessionTrackingId;

          this.saveIPDetails(details);

          // Set value to cookie to prevent the same session entry
          this.cookieService.set(trackerSettings.cookieKey, 'true', 1);
        }
      });
  }

  saveIPDetails(request: TrackUserIpRequestModel) {
    this.httpService.post<any, any>('tracker/TrackUserIp', request).pipe(take(1)).subscribe();
  }

  CheckIfNewSession(key: string): boolean {
    return this.cookieService.get(key) === 'false' || this.cookieService.get(key) === '' ? true : false;
  }
}
